import {
  OnAutoSelectPackage,
  OnPackageSelectionConfirmation,
  OnSelectPackage
} from './package.types'

export const AUTO_SELECT_PACKAGE = 'AUTO_SELECT_PACKAGE'
export const SELECT_PACKAGE = 'SELECT_PACKAGE'
export const PACKAGE_SELECTION_CONFIRMATION = 'PACKAGE_SELECTION_CONFIRMATION'

export const onSelectPackage: OnSelectPackage = idPackage => ({
  payload: {
    idPackage
  },
  type: SELECT_PACKAGE
})

export const onAutoSelectPackage: OnAutoSelectPackage = () => ({
  type: AUTO_SELECT_PACKAGE
})

export const onPackageSelectionConfirmation: OnPackageSelectionConfirmation = () => ({
  type: PACKAGE_SELECTION_CONFIRMATION
})
